// extracted by mini-css-extract-plugin
export var logo = "_5e-2";
export var logoWrapper = "_5e-1";
export var strip = "_5e-0";